// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from "./core/CancelablePromise";
import { OpenAPI } from "./core/OpenAPI";
import { request as __request } from "./core/request";
import type {
  ActionListData,
  ActionListResponse,
  ActionDetailRetrieveData,
  ActionDetailRetrieveResponse,
  ActionDetailCreateData,
  ActionDetailCreateResponse,
  ActionDetailUpdateData,
  ActionDetailUpdateResponse,
  ActionDetailDestroyData,
  ActionDetailDestroyResponse,
  ChatActionsRetrieveData,
  ChatActionsRetrieveResponse,
  ChatIsFlagRetrieveData,
  ChatIsFlagRetrieveResponse,
  ChatJobRecommendListData,
  ChatJobRecommendListResponse,
  ChatMessageNumberRetrieveResponse,
  ChatMessageStaffListData,
  ChatMessageStaffListResponse,
  ChatMessageTalentListData,
  ChatMessageTalentListResponse,
  ChatStaffConventionListData,
  ChatStaffConventionListResponse,
  ChatStaffMessageCreateData,
  ChatStaffMessageCreateResponse,
  ChatTalentConventionListData,
  ChatTalentConventionListResponse,
  ChatTalentJobRecommendListData,
  ChatTalentJobRecommendListResponse,
  ChatTalentMessageCreateData,
  ChatTalentMessageCreateResponse,
  ChatTalentMessageNumberRetrieveResponse,
  ChatTalentRecommendListData,
  ChatTalentRecommendListResponse,
  ChatTalentRetrieveData,
  ChatTalentRetrieveResponse,
  ChatUpdateConversationInfoCreateData,
  ChatUpdateConversationInfoCreateResponse,
  ChatUpdateConversationTalentInfoCreateData,
  ChatUpdateConversationTalentInfoCreateResponse,
  CompanyHomeTalentChartRetrieveData,
  CompanyHomeTalentChartRetrieveResponse,
  CompanyHomeTalentHasChangedJobRetrieveData,
  CompanyHomeTalentHasChangedJobRetrieveResponse,
  CompanyHomeTopViewNewsAndJobRetrieveData,
  CompanyHomeTopViewNewsAndJobRetrieveResponse,
  ContentChartNewsRetrieveData,
  ContentChartNewsRetrieveResponse,
  ContentContentRankingListData,
  ContentContentRankingListResponse,
  ContentCreateCreateData,
  ContentCreateCreateResponse,
  ContentCreateUpdateData,
  ContentCreateUpdateResponse,
  ContentDetailRetrieveData,
  ContentDetailRetrieveResponse,
  ContentDetailUpdateData,
  ContentDetailUpdateResponse,
  ContentDetailDestroyData,
  ContentDetailDestroyResponse,
  ContentManageNewsListListData,
  ContentManageNewsListListResponse,
  ContentManageTopNewsListResponse,
  ContentNotificationListListResponse,
  ContentNotificationSettingRetrieveResponse,
  ContentNotificationSettingCreateData,
  ContentNotificationSettingCreateResponse,
  ContentNotificationSettingUpdateData,
  ContentNotificationSettingUpdateResponse,
  ContentRelatedListData,
  ContentRelatedListResponse,
  ContentUploadFileCreateData,
  ContentUploadFileCreateResponse,
  GenAuthCreateData,
  GenAuthCreateResponse,
  GetCurrentUserRetrieveResponse,
  GetUserInitInfoRetrieveData,
  GetUserInitInfoRetrieveResponse,
  HistoryListData,
  HistoryListResponse,
  JobListData,
  JobListResponse,
  JobUpdateData,
  JobUpdateResponse,
  JobDestroyData,
  JobDestroyResponse,
  JobCreateCreateData,
  JobCreateCreateResponse,
  JobDetailRetrieveData,
  JobDetailRetrieveResponse,
  JobDetailUpdateData,
  JobDetailUpdateResponse,
  JobImportCreateData,
  JobImportCreateResponse,
  JobImportRecordCreateData,
  JobImportRecordCreateResponse,
  JobImportRecordUpdateData,
  JobImportRecordUpdateResponse,
  JobIndustryListListResponse,
  JobOptionRelatedRetrieveData,
  JobOptionRelatedRetrieveResponse,
  JobProfessionListListResponse,
  JobSaveImportCreateData,
  JobSaveImportCreateResponse,
  JobSaveImportPublicCreateData,
  JobSaveImportPublicCreateResponse,
  JobSaveImportPublicUpdateData,
  JobSaveImportPublicUpdateResponse,
  JobTempRetrieveData,
  JobTempRetrieveResponse,
  JobTempDestroyData,
  JobTempDestroyResponse,
  LoginCreateData,
  LoginCreateResponse,
  LogoutCreateResponse,
  MasterCleanUpUploadedFilesRetrieveData,
  MasterCleanUpUploadedFilesRetrieveResponse,
  MasterOptionsMasterListData,
  MasterOptionsMasterListResponse,
  MypageRetrieveResponse,
  MypageBookmarkedListRetrieveData,
  MypageBookmarkedListRetrieveResponse,
  MypageBookmarkedListMobileRetrieveData,
  MypageBookmarkedListMobileRetrieveResponse,
  MypageCareerInfoListResponse,
  MypageCareerInfoUpdateData,
  MypageCareerInfoUpdateResponse,
  MypageChangeBasicInfoUpdateData,
  MypageChangeBasicInfoUpdateResponse,
  MypageChangePasswordCreateData,
  MypageChangePasswordCreateResponse,
  MypageUpdateCreateData,
  MypageUpdateCreateResponse,
  MypageUpdateFullInformationUpdateData,
  MypageUpdateFullInformationUpdateResponse,
  MypageUploadFileCreateData,
  MypageUploadFileCreateResponse,
  MypageUploadFileUpdateData,
  MypageUploadFileUpdateResponse,
  MypageUploadFileDestroyData,
  MypageUploadFileDestroyResponse,
  RecordUserAccessCreateData,
  RecordUserAccessCreateResponse,
  RegisterLinkRegisterLinkListData,
  RegisterLinkRegisterLinkListResponse,
  RegisterLinkRegisterLinkCreateData,
  RegisterLinkRegisterLinkCreateResponse,
  RegisterLinkRegisterLinkUpdateData,
  RegisterLinkRegisterLinkUpdateResponse,
  RegisterLinkRegisterLinkRetrieveData,
  RegisterLinkRegisterLinkRetrieveResponse,
  RegisterLinkRegisterLinkDestroyData,
  RegisterLinkRegisterLinkDestroyResponse,
  ResetPasswordCreateData,
  ResetPasswordCreateResponse,
  ResetPasswordConfirmRetrieveData,
  ResetPasswordConfirmRetrieveResponse,
  ResetPasswordConfirmCreateData,
  ResetPasswordConfirmCreateResponse,
  RestRestCheckRetrieveResponse,
  StaffListData,
  StaffListResponse,
  StaffCreateData,
  StaffCreateResponse,
  StaffRetrieveData,
  StaffRetrieveResponse,
  StaffUpdateData,
  StaffUpdateResponse,
  StaffDestroyData,
  StaffDestroyResponse,
  StaffChangeAvatarUpdateData,
  StaffChangeAvatarUpdateResponse,
  StaffDataListResponse,
  StaffRegisterCreateData,
  StaffRegisterCreateResponse,
  TagTalentTagListData,
  TagTalentTagListResponse,
  TagTalentTagCreateData,
  TagTalentTagCreateResponse,
  TagTalentTagListListData,
  TagTalentTagListListResponse,
  TagTalentTagListUpdateData,
  TagTalentTagListUpdateResponse,
  TagTalentTagOptionsListData,
  TagTalentTagOptionsListResponse,
  TagTalentTagRetrieveData,
  TagTalentTagRetrieveResponse,
  TagTalentTagUpdateData,
  TagTalentTagUpdateResponse,
  TagTalentTagDestroyData,
  TagTalentTagDestroyResponse,
  TalentViewCreateData,
  TalentViewCreateResponse,
  TalentViewBookmarkStatusUpdateData,
  TalentViewBookmarkStatusUpdateResponse,
  TalentViewCalculateTalentJobViewRetrieveResponse,
  TalentViewGetOptionsRelatedRegisterRetrieveResponse,
  TalentViewJobListData,
  TalentViewJobListResponse,
  TalentViewJobMobileListData,
  TalentViewJobMobileListResponse,
  TalentViewJobNotiQuestionRetrieveResponse,
  TalentViewJobNotiQuestionCreateData,
  TalentViewJobNotiQuestionCreateResponse,
  TalentViewJobNotiQuestionUpdateData,
  TalentViewJobNotiQuestionUpdateResponse,
  TalentViewJobOtherListData,
  TalentViewJobOtherListResponse,
  TalentViewJobSuitableListData,
  TalentViewJobSuitableListResponse,
  TalentViewJobSuitableFullListData,
  TalentViewJobSuitableFullListResponse,
  TalentViewJobRetrieveData,
  TalentViewJobRetrieveResponse,
  TalentViewJobCreateData,
  TalentViewJobCreateResponse,
  TalentViewJobUpdateData,
  TalentViewJobUpdateResponse,
  TalentViewNewsListData,
  TalentViewNewsListResponse,
  TalentViewNewsDetailRetrieveData,
  TalentViewNewsDetailRetrieveResponse,
  TalentViewNewsDetailUpdateData,
  TalentViewNewsDetailUpdateResponse,
  TalentViewNewsMobileListData,
  TalentViewNewsMobileListResponse,
  TalentViewNewsRecommendListData,
  TalentViewNewsRecommendListResponse,
  TalentViewNotificationRetrieveResponse,
  TalentViewSyncStatisticsCreateData,
  TalentViewSyncStatisticsCreateResponse,
  TalentViewTalentRegistrationValidateRetrieveData,
  TalentViewTalentRegistrationValidateRetrieveResponse,
  TalentViewUploadFileCreateData,
  TalentViewUploadFileCreateResponse,
  TalentRetrieveData,
  TalentRetrieveResponse,
  TalentUpdateData,
  TalentUpdateResponse2,
  TalentAdvancedSearchCreateData,
  TalentAdvancedSearchCreateResponse,
  TalentApproveBulkCreateData,
  TalentApproveBulkCreateResponse,
  TalentApproveRetrieveData,
  TalentApproveRetrieveResponse,
  TalentBulkMessageListData,
  TalentBulkMessageListResponse,
  TalentBulkMessageCreateData,
  TalentBulkMessageCreateResponse,
  TalentBulkMessageUpdateData,
  TalentBulkMessageUpdateResponse,
  TalentBulkMessageRetrieveData,
  TalentBulkMessageRetrieveResponse,
  TalentBulkMessagePauseCreateData,
  TalentBulkMessagePauseCreateResponse,
  TalentCancelApproveBulkCreateResponse,
  TalentCancelApproveRetrieveData,
  TalentCancelApproveRetrieveResponse,
  TalentCancelTalentCreateData,
  TalentCancelTalentCreateResponse,
  TalentConfirmRegistrationRetrieveData,
  TalentConfirmRegistrationRetrieveResponse,
  TalentConfirmRegistrationCreateData,
  TalentConfirmRegistrationCreateResponse,
  TalentDeleteCreateData,
  TalentDeleteCreateResponse,
  TalentExecuteCloudTaskApproveCreateData,
  TalentExecuteCloudTaskApproveCreateResponse,
  TalentGetListNewListData,
  TalentGetListNewListResponse,
  TalentGetOptionsRelatedRetrieveResponse,
  TalentImportCreateData,
  TalentImportCreateResponse,
  TalentJobRecommendRetrieveData,
  TalentJobRecommendRetrieveResponse,
  TalentNewsRecommendRetrieveData,
  TalentNewsRecommendRetrieveResponse,
  TalentReferrerTalentRetrieveData,
  TalentReferrerTalentRetrieveResponse,
  TalentResendApproveEmailRetrieveData,
  TalentResendApproveEmailRetrieveResponse,
  TalentSaveImportCreateData,
  TalentSaveImportCreateResponse,
  TalentStatisticsRetrieveData,
  TalentStatisticsRetrieveResponse,
  TalentUpdateInfoCreateData,
  TalentUpdateInfoCreateResponse,
  TalentUpdateResumeCreateData,
  TalentUpdateResumeCreateResponse,
  UpdateAdminSessionTimeOutRetrieveData,
  UpdateAdminSessionTimeOutRetrieveResponse,
  UpdateAdminSessionTimeOutCreateData,
  UpdateAdminSessionTimeOutCreateResponse,
  ControlApiCompanyListData,
  ControlApiCompanyListResponse,
  ControlApiCompanyCreateData,
  ControlApiCompanyCreateResponse,
  ControlApiCompanyRetrieveData,
  ControlApiCompanyRetrieveResponse,
  ControlApiCompanyUpdateData,
  ControlApiCompanyUpdateResponse,
  ControlApiCompanyDestroyData,
  ControlApiCompanyDestroyResponse,
  ControlApiCompanyExportCsvRetrieveData,
  ControlApiCompanyExportCsvRetrieveResponse,
  ControlApiCompanyGetDefaultCompanyIdRetrieveResponse,
  ControlApiDepartmentListData,
  ControlApiDepartmentListResponse,
  ControlApiDepartmentCreateData,
  ControlApiDepartmentCreateResponse,
  ControlApiDepartmentRetrieveData,
  ControlApiDepartmentRetrieveResponse,
  ControlApiDepartmentUpdateData,
  ControlApiDepartmentUpdateResponse,
  ControlApiDepartmentDestroyData,
  ControlApiDepartmentDestroyResponse,
  ControlApiPositionListData,
  ControlApiPositionListResponse,
  ControlApiPositionCreateData,
  ControlApiPositionCreateResponse,
  ControlApiPositionUpdateData,
  ControlApiPositionUpdateResponse,
  ControlApiPositionDestroyData,
  ControlApiPositionDestroyResponse,
  ControlApiSuperUserListData,
  ControlApiSuperUserListResponse,
  ControlApiSuperUserCreateData,
  ControlApiSuperUserCreateResponse,
  ControlApiSuperUserLoginCreateResponse,
  ControlApiSuperUserRetrieveData,
  ControlApiSuperUserRetrieveResponse,
  ControlApiSuperUserUpdateData,
  ControlApiSuperUserUpdateResponse,
  ControlApiSuperUserDestroyData,
  ControlApiSuperUserDestroyResponse,
  ControlApiSuperUserChangeAdminCompanyCreateData,
  ControlApiSuperUserChangeAdminCompanyCreateResponse,
  ControlApiSuperUserGetOptionsRelatedRetrieveResponse,
  ControlApiSuperUserUpdateAvatarUpdateData,
  ControlApiSuperUserUpdateAvatarUpdateResponse,
} from "./types.gen";

export class ActionService {
  /**
   * Get list actions
   * Get list actions.
   * @param data The data for the request.
   * @param data.page Page
   * @param data.pageSize Page size
   * @param data.searchJob Filtering job
   * @param data.searchStaff Filtering staff
   * @param data.searchTalent Filtering talent
   * @param data.sortBy Field to sort by (e.g., department, position)
   * @param data.status Filtering status
   * @returns ListActionPaging
   * @throws ApiError
   */
  public static actionList(
    data: ActionListData = {},
  ): CancelablePromise<ActionListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/action",
      query: {
        page: data.page,
        page_size: data.pageSize,
        search_job: data.searchJob,
        search_staff: data.searchStaff,
        search_talent: data.searchTalent,
        sort_by: data.sortBy,
        status: data.status,
      },
    });
  }

  /**
   * Get detail action
   * Get detail action by ID.
   * @param data The data for the request.
   * @param data.id
   * @returns ActionDetailView
   * @throws ApiError
   */
  public static actionDetailRetrieve(
    data: ActionDetailRetrieveData,
  ): CancelablePromise<ActionDetailRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/action/detail/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Add new action detail
   * Add new action detail.
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static actionDetailCreate(
    data: ActionDetailCreateData,
  ): CancelablePromise<ActionDetailCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/action/detail/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Update action item
   * Update action item.
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static actionDetailUpdate(
    data: ActionDetailUpdateData,
  ): CancelablePromise<ActionDetailUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/action/detail/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Delete action detail
   * Delete action detail.
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static actionDetailDestroy(
    data: ActionDetailDestroyData,
  ): CancelablePromise<ActionDetailDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/action/detail/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Get options related action
   * Get options related action.
   * @throws ApiError
   */
  public static actionGetOptionsRelatedRetrieve(): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/action/get-options-related",
    });
  }
}

export class ChatService {
  /**
   * Get action by conversation id
   * Get action by conversation id.
   * @param data The data for the request.
   * @param data.chatConversationId
   * @returns MessageActionView
   * @throws ApiError
   */
  public static chatActionsRetrieve(
    data: ChatActionsRetrieveData,
  ): CancelablePromise<ChatActionsRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/chat/actions/{chat_conversation_id}",
      path: {
        chat_conversation_id: data.chatConversationId,
      },
    });
  }

  /**
   * Update is flag conversation
   * Update is flag conversation.
   * @param data The data for the request.
   * @param data.id
   * @returns IsFlagResponse
   * @throws ApiError
   */
  public static chatIsFlagRetrieve(
    data: ChatIsFlagRetrieveData,
  ): CancelablePromise<ChatIsFlagRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/chat/is-flag/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Get list job recommend
   * Get list job recommend.
   * @param data The data for the request.
   * @param data.page Page number
   * @param data.pageSize Page size
   * @param data.search Search text
   * @param data.talentId Talent ID
   * @param data.talentIds Talent IDs
   * @returns ChatJobRecommend
   * @throws ApiError
   */
  public static chatJobRecommendList(
    data: ChatJobRecommendListData = {},
  ): CancelablePromise<ChatJobRecommendListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/chat/job-recommend",
      query: {
        page: data.page,
        page_size: data.pageSize,
        search: data.search,
        talent_id: data.talentId,
        talent_ids: data.talentIds,
      },
    });
  }

  /**
   * Get number of notification
   * Get number of notification.
   * @returns unknown
   * @throws ApiError
   */
  public static chatMessageNumberRetrieve(): CancelablePromise<ChatMessageNumberRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/chat/message-number",
    });
  }

  /**
   * Get list messages by conversation id
   * Get list messages by conversation id.
   * @param data The data for the request.
   * @param data.id
   * @returns ChatMessage
   * @throws ApiError
   */
  public static chatMessageStaffList(
    data: ChatMessageStaffListData,
  ): CancelablePromise<ChatMessageStaffListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/chat/message-staff/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Get list messages by conversation id
   * Get list messages by conversation id.
   * @param data The data for the request.
   * @param data.id
   * @returns ChatMessage
   * @throws ApiError
   */
  public static chatMessageTalentList(
    data: ChatMessageTalentListData,
  ): CancelablePromise<ChatMessageTalentListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/chat/message-talent/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Get list chat conversation
   * Get list chat conversation.
   * @param data The data for the request.
   * @param data.filter Filter by talent ID, talent name, admin name
   * @param data.isFlag Filter by message flag
   * @param data.page Page
   * @param data.pageSize Page size
   * @returns ChatConversation
   * @throws ApiError
   */
  public static chatStaffConventionList(
    data: ChatStaffConventionListData = {},
  ): CancelablePromise<ChatStaffConventionListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/chat/staff-convention",
      query: {
        filter: data.filter,
        is_flag: data.isFlag,
        page: data.page,
        page_size: data.pageSize,
      },
    });
  }

  /**
   * Staff send message
   * Staff send message.
   * @param data The data for the request.
   * @param data.formData
   * @returns unknown
   * @throws ApiError
   */
  public static chatStaffMessageCreate(
    data: ChatStaffMessageCreateData = {},
  ): CancelablePromise<ChatStaffMessageCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/chat/staff-message",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * Get list chat talent conversation
   * Get list chat talent conversation.
   * @param data The data for the request.
   * @param data.page Page
   * @param data.pageSize Page size
   * @returns TalentChatConversation
   * @throws ApiError
   */
  public static chatTalentConventionList(
    data: ChatTalentConventionListData = {},
  ): CancelablePromise<ChatTalentConventionListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/chat/talent-convention",
      query: {
        page: data.page,
        page_size: data.pageSize,
      },
    });
  }

  /**
   * Get list job recommend for talent
   * Get list job recommend for talent.
   * @param data The data for the request.
   * @param data.page Page number
   * @param data.pageSize Page size
   * @param data.search Search text
   * @returns ChatJobRecommend
   * @throws ApiError
   */
  public static chatTalentJobRecommendList(
    data: ChatTalentJobRecommendListData = {},
  ): CancelablePromise<ChatTalentJobRecommendListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/chat/talent-job-recommend",
      query: {
        page: data.page,
        page_size: data.pageSize,
        search: data.search,
      },
    });
  }

  /**
   * Talent send message
   * Talent send message.
   * @param data The data for the request.
   * @param data.formData
   * @returns unknown
   * @throws ApiError
   */
  public static chatTalentMessageCreate(
    data: ChatTalentMessageCreateData = {},
  ): CancelablePromise<ChatTalentMessageCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/chat/talent-message",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * Get number of notification
   * Get number of notification.
   * @returns unknown
   * @throws ApiError
   */
  public static chatTalentMessageNumberRetrieve(): CancelablePromise<ChatTalentMessageNumberRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/chat/talent-message-number",
    });
  }

  /**
   * Get list talents recommend
   * Get list talents recommend.
   * @param data The data for the request.
   * @param data.search Search text
   * @returns ChatTalentRecommend
   * @throws ApiError
   */
  public static chatTalentRecommendList(
    data: ChatTalentRecommendListData = {},
  ): CancelablePromise<ChatTalentRecommendListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/chat/talent-recommend",
      query: {
        search: data.search,
      },
    });
  }

  /**
   * Get detail talent
   * Get detail talent by ID.
   * @param data The data for the request.
   * @param data.id
   * @returns TalentInfo
   * @throws ApiError
   */
  public static chatTalentRetrieve(
    data: ChatTalentRetrieveData,
  ): CancelablePromise<ChatTalentRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/chat/talent/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Update the conversation information
   * Update the conversation information.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static chatUpdateConversationInfoCreate(
    data: ChatUpdateConversationInfoCreateData,
  ): CancelablePromise<ChatUpdateConversationInfoCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/chat/update-conversation-info",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Update the conversation information
   * Update the conversation information.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static chatUpdateConversationTalentInfoCreate(
    data: ChatUpdateConversationTalentInfoCreateData,
  ): CancelablePromise<ChatUpdateConversationTalentInfoCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/chat/update-conversation-talent-info",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class CompanyHomeService {
  /**
   * company home talent chart
   * Get data for chart in company dashboard page
   * @param data The data for the request.
   * @param data.rankAonly Filter to include only talent company with rank A
   * @param data.talentType Talent type filter
   * @param data.time Time filter: 1 for this month, 2 for last month, 3 for past 30 days,...
   * @returns CompanyDashboardChartResponse
   * @throws ApiError
   */
  public static companyHomeTalentChartRetrieve(
    data: CompanyHomeTalentChartRetrieveData = {},
  ): CancelablePromise<CompanyHomeTalentChartRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/company-home/talent-chart",
      query: {
        rankAOnly: data.rankAonly,
        talent_type: data.talentType,
        time: data.time,
      },
    });
  }

  /**
   * Get list talents have change job for company home
   * Get list talents have change job for company home.
   * @param data The data for the request.
   * @param data.rankAonly Rank A only
   * @param data.talentType Talent type filter
   * @returns GetTalentHasChangedJob
   * @throws ApiError
   */
  public static companyHomeTalentHasChangedJobRetrieve(
    data: CompanyHomeTalentHasChangedJobRetrieveData = {},
  ): CancelablePromise<CompanyHomeTalentHasChangedJobRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/company-home/talent-has-changed-job",
      query: {
        rankAOnly: data.rankAonly,
        talent_type: data.talentType,
      },
    });
  }

  /**
   * Get list news, jobs top view
   * Get list news, jobs top view.
   * @param data The data for the request.
   * @param data.rankAonly Rank A only
   * @param data.talentType Talent type filter
   * @returns TopNews
   * @throws ApiError
   */
  public static companyHomeTopViewNewsAndJobRetrieve(
    data: CompanyHomeTopViewNewsAndJobRetrieveData = {},
  ): CancelablePromise<CompanyHomeTopViewNewsAndJobRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/company-home/top-view-news-and-job",
      query: {
        rankAOnly: data.rankAonly,
        talent_type: data.talentType,
      },
    });
  }
}

export class ContentService {
  /**
   * Get chart news
   * Returns chart of news in the system.
   * @param data The data for the request.
   * @param data.option Option
   * @returns unknown
   * @throws ApiError
   */
  public static contentChartNewsRetrieve(
    data: ContentChartNewsRetrieveData = {},
  ): CancelablePromise<ContentChartNewsRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/content/chart-news",
      query: {
        option: data.option,
      },
    });
  }

  /**
   * Get the list of content rankings
   * Returns a list of content rankings in the system.
   * @param data The data for the request.
   * @param data.page Page
   * @param data.pageSize Page size
   * @param data.rankAOnly Filter to include only talent company with rank A
   * @param data.talentType Talent type filter
   * @returns News
   * @throws ApiError
   */
  public static contentContentRankingList(
    data: ContentContentRankingListData = {},
  ): CancelablePromise<ContentContentRankingListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/content/content-ranking",
      query: {
        page: data.page,
        page_size: data.pageSize,
        rank_a_only: data.rankAOnly,
        talent_type: data.talentType,
      },
    });
  }

  /**
   * Create a news
   * Create a news.
   * @param data The data for the request.
   * @param data.formData
   * @returns CreateNewsResponse
   * @throws ApiError
   */
  public static contentCreateCreate(
    data: ContentCreateCreateData = {},
  ): CancelablePromise<ContentCreateCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/content/create",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * Update news status
   * Update news status.
   * @param data The data for the request.
   * @param data.formData
   * @returns NewsDetail
   * @throws ApiError
   */
  public static contentCreateUpdate(
    data: ContentCreateUpdateData,
  ): CancelablePromise<ContentCreateUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/content/create",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * Get content detail
   * Get details of an content based on ID.
   * @param data The data for the request.
   * @param data.id
   * @returns NewsDetail
   * @throws ApiError
   */
  public static contentDetailRetrieve(
    data: ContentDetailRetrieveData,
  ): CancelablePromise<ContentDetailRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/content/detail/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Update content detail
   * Update content information based on ID.
   * @param data The data for the request.
   * @param data.id
   * @param data.formData
   * @returns UpdateNewsResponse
   * @throws ApiError
   */
  public static contentDetailUpdate(
    data: ContentDetailUpdateData,
  ): CancelablePromise<ContentDetailUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/content/detail/{id}",
      path: {
        id: data.id,
      },
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * Delete News
   * Delete News in the system.
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static contentDetailDestroy(
    data: ContentDetailDestroyData,
  ): CancelablePromise<ContentDetailDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/content/detail/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Get the list of news
   * Returns a list of news in the system.
   * @param data The data for the request.
   * @param data.page Page
   * @param data.pageSize Page size
   * @returns NewsListBasic
   * @throws ApiError
   */
  public static contentManageNewsListList(
    data: ContentManageNewsListListData = {},
  ): CancelablePromise<ContentManageNewsListListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/content/manage/news-list",
      query: {
        page: data.page,
        page_size: data.pageSize,
      },
    });
  }

  /**
   * Get the top news
   * Returns a top news in the system.
   * @returns NewsRanking
   * @throws ApiError
   */
  public static contentManageTopNewsList(): CancelablePromise<ContentManageTopNewsListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/content/manage/top-news",
    });
  }

  /**
   * Get the notification
   * Returns notification in the system.
   * @returns Noti
   * @throws ApiError
   */
  public static contentNotificationListList(): CancelablePromise<ContentNotificationListListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/content/notification-list",
    });
  }

  /**
   * Get the notification setting
   * Returns notification setting in the system.
   * @returns NotiSettingBasic
   * @throws ApiError
   */
  public static contentNotificationSettingRetrieve(): CancelablePromise<ContentNotificationSettingRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/content/notification-setting",
    });
  }

  /**
   * Create notification setting
   * Create notification setting in the system.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns NotiSettingBasic
   * @throws ApiError
   */
  public static contentNotificationSettingCreate(
    data: ContentNotificationSettingCreateData,
  ): CancelablePromise<ContentNotificationSettingCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/content/notification-setting",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Update notification setting
   * Update notification setting based on ID.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns NotiSettingBasic
   * @throws ApiError
   */
  public static contentNotificationSettingUpdate(
    data: ContentNotificationSettingUpdateData,
  ): CancelablePromise<ContentNotificationSettingUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/content/notification-setting",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Get the related news
   * Returns related news in the system.
   * @param data The data for the request.
   * @param data.id
   * @returns NewsListBasic
   * @throws ApiError
   */
  public static contentRelatedList(
    data: ContentRelatedListData,
  ): CancelablePromise<ContentRelatedListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/content/related/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Upload files
   * Upload files.
   * @param data The data for the request.
   * @param data.formData
   * @returns UploadFileResponse
   * @throws ApiError
   */
  public static contentUploadFileCreate(
    data: ContentUploadFileCreateData = {},
  ): CancelablePromise<ContentUploadFileCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/content/upload-file",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }
}

export class GenAuthService {
  /**
   * Gen authen code
   * Gen authen code.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns GenAuthResponse
   * @throws ApiError
   */
  public static genAuthCreate(
    data: GenAuthCreateData,
  ): CancelablePromise<GenAuthCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/gen_auth",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class GetCurrentUserService {
  /**
   * @returns User
   * @throws ApiError
   */
  public static getCurrentUserRetrieve(): CancelablePromise<GetCurrentUserRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/get_current_user",
    });
  }
}

export class GetUserInitInfoService {
  /**
   * Get user info
   * Get user info.
   * @param data The data for the request.
   * @param data.registerCode Register code for new user
   * @returns User
   * @throws ApiError
   */
  public static getUserInitInfoRetrieve(
    data: GetUserInitInfoRetrieveData,
  ): CancelablePromise<GetUserInitInfoRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/get_user_init_info",
      query: {
        register_code: data.registerCode,
      },
    });
  }
}

export class HistoryService {
  /**
   * History list
   * History list in the system.
   * @param data The data for the request.
   * @param data.endDate End date of the range
   * @param data.page Page
   * @param data.pageSize Page size
   * @param data.search Search query for filtering job by created_at, type, screen_name, detail
   * @param data.sortBy Field to sort by (e.g., department, position)
   * @param data.sortOrder Sort order (asc or desc)
   * @param data.startDate Start date of the range
   * @returns StaffActionHistory
   * @throws ApiError
   */
  public static historyList(
    data: HistoryListData = {},
  ): CancelablePromise<HistoryListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/history",
      query: {
        end_date: data.endDate,
        page: data.page,
        page_size: data.pageSize,
        search: data.search,
        sort_by: data.sortBy,
        sort_order: data.sortOrder,
        start_date: data.startDate,
      },
    });
  }
}

export class JobService {
  /**
   * Job list
   * Job list in the system.
   * @param data The data for the request.
   * @param data.option Option
   * @param data.page Page
   * @param data.pageSize Page size
   * @param data.rankAOnly Filter to include only talent company with rank A
   * @param data.search Search query for filtering job by title, status, type, occupation_2, public_date, number_of_views, number_of_saves, number_of_responses
   * @param data.sortBy Field to sort by (e.g., department, position)
   * @param data.sortOrder Sort order (asc or desc)
   * @param data.talentType Talent type filter
   * @returns JobList
   * @throws ApiError
   */
  public static jobList(
    data: JobListData = {},
  ): CancelablePromise<JobListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/job/",
      query: {
        option: data.option,
        page: data.page,
        page_size: data.pageSize,
        rank_a_only: data.rankAOnly,
        search: data.search,
        sort_by: data.sortBy,
        sort_order: data.sortOrder,
        talent_type: data.talentType,
      },
    });
  }

  /**
   * Update Status Job
   * Update Status Job in the system.
   * @param data The data for the request.
   * @param data.id Only one job ID
   * @param data.status Status ID
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static jobUpdate(
    data: JobUpdateData,
  ): CancelablePromise<JobUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/job/",
      query: {
        id: data.id,
        status: data.status,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Delete Job
   * Delete Job in the system.
   * @param data The data for the request.
   * @param data.ids Comma-separated list of Job ID (e.g., 1,2,3)
   * @returns unknown
   * @throws ApiError
   */
  public static jobDestroy(
    data: JobDestroyData,
  ): CancelablePromise<JobDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/job/",
      query: {
        ids: data.ids,
      },
    });
  }

  /**
   * Create job
   * Create a new job in the system.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Job
   * @throws ApiError
   */
  public static jobCreateCreate(
    data: JobCreateCreateData,
  ): CancelablePromise<JobCreateCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/job/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Get job detail
   * Get details of a job based on ID.
   * @param data The data for the request.
   * @param data.id
   * @returns JobDetail
   * @throws ApiError
   */
  public static jobDetailRetrieve(
    data: JobDetailRetrieveData,
  ): CancelablePromise<JobDetailRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/job/detail/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Update Job
   * Update Job in the system.
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns JobDetail
   * @throws ApiError
   */
  public static jobDetailUpdate(
    data: JobDetailUpdateData,
  ): CancelablePromise<JobDetailUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/job/detail/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Import job from CSV file
   * Import job from CSV file.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static jobImportCreate(
    data: JobImportCreateData,
  ): CancelablePromise<JobImportCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/job/import",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Save and public only one job record
   * Save and public only one job record based on ID.
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns JobPublicFromImport
   * @throws ApiError
   */
  public static jobImportRecordCreate(
    data: JobImportRecordCreateData,
  ): CancelablePromise<JobImportRecordCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/job/import/record/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Public job from import
   * Public job from import.
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns JobPublicFromImport
   * @throws ApiError
   */
  public static jobImportRecordUpdate(
    data: JobImportRecordUpdateData,
  ): CancelablePromise<JobImportRecordUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/job/import/record/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Get industry list
   * Get industry list in the system.
   * @returns Industry
   * @throws ApiError
   */
  public static jobIndustryListList(): CancelablePromise<JobIndustryListListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/job/industry-list",
    });
  }

  /**
   * Get Options Master related job
   * Get options master related job.
   * @param data The data for the request.
   * @param data.option Comma-separated list of Option Type names (e.g., Name1, Name2)
   * @returns OptionRelatedJobResponse
   * @throws ApiError
   */
  public static jobOptionRelatedRetrieve(
    data: JobOptionRelatedRetrieveData = {},
  ): CancelablePromise<JobOptionRelatedRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/job/option-related",
      query: {
        option: data.option,
      },
    });
  }

  /**
   * Get profession list
   * Get profession list in the system.
   * @returns Profession
   * @throws ApiError
   */
  public static jobProfessionListList(): CancelablePromise<JobProfessionListListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/job/profession-list",
    });
  }

  /**
   * Save job import temp to job
   * Save job import temp to job.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static jobSaveImportCreate(
    data: JobSaveImportCreateData,
  ): CancelablePromise<JobSaveImportCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/job/save-import",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Save job import temp to job with public
   * Save job import temp to job with public.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static jobSaveImportPublicCreate(
    data: JobSaveImportPublicCreateData,
  ): CancelablePromise<JobSaveImportPublicCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/job/save-import-public",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Update public job
   * Update public job.
   * @param data The data for the request.
   * @param data.ids Comma-separated list of Job ID (e.g., 1,2,3)
   * @param data.requestBody
   * @returns JobPublicFromImport
   * @throws ApiError
   */
  public static jobSaveImportPublicUpdate(
    data: JobSaveImportPublicUpdateData,
  ): CancelablePromise<JobSaveImportPublicUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/job/save-import-public",
      query: {
        ids: data.ids,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Get job detail temp
   * Get details of a job temp based on ID.
   * @param data The data for the request.
   * @param data.id
   * @returns JobTemp
   * @throws ApiError
   */
  public static jobTempRetrieve(
    data: JobTempRetrieveData,
  ): CancelablePromise<JobTempRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/job/temp/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Delete Job Temp
   * Delete Job Temp in the system.
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static jobTempDestroy(
    data: JobTempDestroyData,
  ): CancelablePromise<JobTempDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/job/temp/{id}",
      path: {
        id: data.id,
      },
    });
  }
}

export class LoginService {
  /**
   * Login
   * Login.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns User
   * @throws ApiError
   */
  public static loginCreate(
    data: LoginCreateData,
  ): CancelablePromise<LoginCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/login",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class LogoutService {
  /**
   * Logout
   * Logout.
   * @returns LogoutResponse
   * @throws ApiError
   */
  public static logoutCreate(): CancelablePromise<LogoutCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/logout",
    });
  }
}

export class MasterService {
  /**
   * Cleanup uploaded files
   * Remove uploaded files from bucket storage if not exists in database
   * @param data The data for the request.
   * @param data.authorization Authorization Bearer token or API key.
   * @param data.xApiKey API key for cloud scheduler authentication.
   * @returns CleanupUploadedFilesResponse
   * @throws ApiError
   */
  public static masterCleanUpUploadedFilesRetrieve(
    data: MasterCleanUpUploadedFilesRetrieveData = {},
  ): CancelablePromise<MasterCleanUpUploadedFilesRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/clean-up-uploaded-files",
      headers: {
        Authorization: data.authorization,
        "X-Api-Key": data.xApiKey,
      },
    });
  }

  /**
   * Get Options Master
   * Get options master in the system.
   * @param data The data for the request.
   * @param data.option Comma-separated list of Option Masters (e.g., 1,2,3)
   * @returns OptionsType
   * @throws ApiError
   */
  public static masterOptionsMasterList(
    data: MasterOptionsMasterListData,
  ): CancelablePromise<MasterOptionsMasterListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/options-master",
      query: {
        option: data.option,
      },
    });
  }
}

export class MypageService {
  /**
   * Get detail talent in my page
   * Get detail talent by email.
   * @returns Mypage
   * @throws ApiError
   */
  public static mypageRetrieve(): CancelablePromise<MypageRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/mypage",
    });
  }

  /**
   * Get all the marked list
   * Get all the marked list.
   * @param data The data for the request.
   * @param data.page Page
   * @param data.pageSize Page size
   * @returns unknown
   * @throws ApiError
   */
  public static mypageBookmarkedListRetrieve(
    data: MypageBookmarkedListRetrieveData = {},
  ): CancelablePromise<MypageBookmarkedListRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/mypage/bookmarked-list",
      query: {
        page: data.page,
        page_size: data.pageSize,
      },
    });
  }

  /**
   * Get all the marked list on mobile
   * Get all the marked list on mobile.
   * @param data The data for the request.
   * @param data.page Page
   * @param data.pageSize Page size
   * @returns unknown
   * @throws ApiError
   */
  public static mypageBookmarkedListMobileRetrieve(
    data: MypageBookmarkedListMobileRetrieveData = {},
  ): CancelablePromise<MypageBookmarkedListMobileRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/mypage/bookmarked-list-mobile",
      query: {
        page: data.page,
        page_size: data.pageSize,
      },
    });
  }

  /**
   * Get talent career information
   * Get details of an talent career information based on ID.
   * @returns TalentCareer
   * @throws ApiError
   */
  public static mypageCareerInfoList(): CancelablePromise<MypageCareerInfoListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/mypage/career-info",
    });
  }

  /**
   * Update talent career information
   * Update talent career information based on input value
   * @param data The data for the request.
   * @param data.formData
   * @returns unknown
   * @throws ApiError
   */
  public static mypageCareerInfoUpdate(
    data: MypageCareerInfoUpdateData = {},
  ): CancelablePromise<MypageCareerInfoUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/mypage/career-info",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * Update talent information
   * Update talent information based on ID.
   * @param data The data for the request.
   * @param data.formData
   * @returns unknown
   * @throws ApiError
   */
  public static mypageChangeBasicInfoUpdate(
    data: MypageChangeBasicInfoUpdateData = {},
  ): CancelablePromise<MypageChangeBasicInfoUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/mypage/change-basic-info",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * Change password on my page
   * Change password on my page.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns ChangePasswordResponse
   * @throws ApiError
   */
  public static mypageChangePasswordCreate(
    data: MypageChangePasswordCreateData,
  ): CancelablePromise<MypageChangePasswordCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/mypage/change-password",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Update talent info on my page
   * Update talent info on my page.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static mypageUpdateCreate(
    data: MypageUpdateCreateData,
  ): CancelablePromise<MypageUpdateCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/mypage/update",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Update talent with all information
   * Update talent with all information.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns MypageUpdateFullInformationResponse
   * @throws ApiError
   */
  public static mypageUpdateFullInformationUpdate(
    data: MypageUpdateFullInformationUpdateData,
  ): CancelablePromise<MypageUpdateFullInformationUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/mypage/update-full-information",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Talent upload files
   * Talent upload files.
   * @param data The data for the request.
   * @param data.formData
   * @returns TalentUploadFileResponse
   * @throws ApiError
   */
  public static mypageUploadFileCreate(
    data: MypageUploadFileCreateData = {},
  ): CancelablePromise<MypageUploadFileCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/mypage/upload-file",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * Talent update uploaded file
   * Talent update uploaded file.
   * @param data The data for the request.
   * @param data.id
   * @param data.formData
   * @returns TalentUploadFileDetailResponse
   * @throws ApiError
   */
  public static mypageUploadFileUpdate(
    data: MypageUploadFileUpdateData,
  ): CancelablePromise<MypageUploadFileUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/mypage/upload-file/{id}",
      path: {
        id: data.id,
      },
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * Talent delete uploaded file
   * Talent delete uploaded file.
   * @param data The data for the request.
   * @param data.id
   * @returns TalentUploadFileDetailResponse
   * @throws ApiError
   */
  public static mypageUploadFileDestroy(
    data: MypageUploadFileDestroyData,
  ): CancelablePromise<MypageUploadFileDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/mypage/upload-file/{id}",
      path: {
        id: data.id,
      },
    });
  }
}

export class RecordUserAccessService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns User
   * @throws ApiError
   */
  public static recordUserAccessCreate(
    data: RecordUserAccessCreateData,
  ): CancelablePromise<RecordUserAccessCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/record-user-access",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class RegisterLinkService {
  /**
   * Get list register link
   * Get list register link.
   * @param data The data for the request.
   * @param data.page Page
   * @param data.pageSize Page size
   * @param data.searchQuery Filtering register link
   * @param data.sortBy Field to sort by (e.g., public_date)
   * @param data.sortOrder Sort order (asc or desc)
   * @returns RegisterLink
   * @throws ApiError
   */
  public static registerLinkRegisterLinkList(
    data: RegisterLinkRegisterLinkListData = {},
  ): CancelablePromise<RegisterLinkRegisterLinkListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/register-link/register-link",
      query: {
        page: data.page,
        page_size: data.pageSize,
        search_query: data.searchQuery,
        sort_by: data.sortBy,
        sort_order: data.sortOrder,
      },
    });
  }

  /**
   * Add new register link
   * Add new register link.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static registerLinkRegisterLinkCreate(
    data: RegisterLinkRegisterLinkCreateData,
  ): CancelablePromise<RegisterLinkRegisterLinkCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/register-link/register-link",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Update register link
   * Update register link.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static registerLinkRegisterLinkUpdate(
    data: RegisterLinkRegisterLinkUpdateData,
  ): CancelablePromise<RegisterLinkRegisterLinkUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/register-link/register-link",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Get detail register link
   * Get detail register link by ID.
   * @param data The data for the request.
   * @param data.id
   * @returns RegisterLink
   * @throws ApiError
   */
  public static registerLinkRegisterLinkRetrieve(
    data: RegisterLinkRegisterLinkRetrieveData,
  ): CancelablePromise<RegisterLinkRegisterLinkRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/register-link/register-link/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Delete register link
   * Delete register link.
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static registerLinkRegisterLinkDestroy(
    data: RegisterLinkRegisterLinkDestroyData,
  ): CancelablePromise<RegisterLinkRegisterLinkDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/register-link/register-link/{id}",
      path: {
        id: data.id,
      },
    });
  }
}

export class ResetPasswordService {
  /**
   * Reset password
   * Reset password.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns ResetPasswordResponse
   * @throws ApiError
   */
  public static resetPasswordCreate(
    data: ResetPasswordCreateData,
  ): CancelablePromise<ResetPasswordCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/reset_password",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class ResetPasswordConfirmService {
  /**
   * Check reset password code
   * Check reset password code.
   * @param data The data for the request.
   * @param data.resetPasswordCode Reset password code
   * @param data.view View
   * @returns unknown
   * @throws ApiError
   */
  public static resetPasswordConfirmRetrieve(
    data: ResetPasswordConfirmRetrieveData,
  ): CancelablePromise<ResetPasswordConfirmRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/reset_password_confirm",
      query: {
        reset_password_code: data.resetPasswordCode,
        view: data.view,
      },
    });
  }

  /**
   * Confirm reset password
   * Confirm reset password.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns ResetPasswordConfirmResponse
   * @throws ApiError
   */
  public static resetPasswordConfirmCreate(
    data: ResetPasswordConfirmCreateData,
  ): CancelablePromise<ResetPasswordConfirmCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/reset_password_confirm",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class RestService {
  /**
   * Check REST API
   * This endpoint checks if the REST API is working.
   * @returns Message
   * @throws ApiError
   */
  public static restRestCheckRetrieve(): CancelablePromise<RestRestCheckRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/rest/rest-check/",
    });
  }
}

export class StaffService {
  /**
   * Get a list of all staffs
   * Returns a list of all staffs in the system.
   * @param data The data for the request.
   * @param data.page Page
   * @param data.pageSize Page size
   * @param data.search Search query for filtering staff by name, email, department, position, type, create_at, updated_at
   * @param data.sortBy Field to sort by (e.g., department, position)
   * @param data.sortOrder Sort order (asc or desc)
   * @returns StaffList
   * @throws ApiError
   */
  public static staffList(
    data: StaffListData = {},
  ): CancelablePromise<StaffListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/staff/",
      query: {
        page: data.page,
        page_size: data.pageSize,
        search: data.search,
        sort_by: data.sortBy,
        sort_order: data.sortOrder,
      },
    });
  }

  /**
   * Create staff
   * Create a new staff in the system.
   * @param data The data for the request.
   * @param data.formData
   * @returns StaffCreate
   * @throws ApiError
   */
  public static staffCreate(
    data: StaffCreateData = {},
  ): CancelablePromise<StaffCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/staff/",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * Get staff information
   * Get details of an staff based on ID.
   * @param data The data for the request.
   * @param data.id
   * @returns StaffDetail
   * @throws ApiError
   */
  public static staffRetrieve(
    data: StaffRetrieveData,
  ): CancelablePromise<StaffRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/staff/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Update staff information
   * Update staff information based on ID.
   * @param data The data for the request.
   * @param data.id
   * @param data.formData
   * @returns StaffList
   * @throws ApiError
   */
  public static staffUpdate(
    data: StaffUpdateData,
  ): CancelablePromise<StaffUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/staff/{id}",
      path: {
        id: data.id,
      },
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * Delete staff
   * Remove an employee from the system based on ID.
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static staffDestroy(
    data: StaffDestroyData,
  ): CancelablePromise<StaffDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/staff/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Update staff avatar
   * Update staff avatar based on ID.
   * @param data The data for the request.
   * @param data.id
   * @param data.formData
   * @returns StaffList
   * @throws ApiError
   */
  public static staffChangeAvatarUpdate(
    data: StaffChangeAvatarUpdateData,
  ): CancelablePromise<StaffChangeAvatarUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/staff/change-avatar/{id}",
      path: {
        id: data.id,
      },
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * Get a list of all staff data
   * Returns a list of all staff data in the system.
   * @returns StaffList
   * @throws ApiError
   */
  public static staffDataList(): CancelablePromise<StaffDataListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/staff/data/",
    });
  }
}

export class StaffRegisterService {
  /**
   * Register staff
   * Register staff.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns User
   * @throws ApiError
   */
  public static staffRegisterCreate(
    data: StaffRegisterCreateData,
  ): CancelablePromise<StaffRegisterCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/staff_register",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class TagService {
  /**
   * Get talent tags
   * Get talent tags.
   * @param data The data for the request.
   * @param data.page Page
   * @param data.pageSize Page size
   * @param data.searchQuery Filtering talent tags
   * @param data.sortBy Field to sort by (e.g., title, number_of_talent)
   * @param data.sortOrder Sort order (e.g., title, number_of_talent)
   * @returns Tag
   * @throws ApiError
   */
  public static tagTalentTagList(
    data: TagTalentTagListData = {},
  ): CancelablePromise<TagTalentTagListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/tag/talent-tag",
      query: {
        page: data.page,
        page_size: data.pageSize,
        search_query: data.searchQuery,
        sort_by: data.sortBy,
        sort_order: data.sortOrder,
      },
    });
  }

  /**
   * Add new talent tag
   * Add new talent tag.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Tag
   * @throws ApiError
   */
  public static tagTalentTagCreate(
    data: TagTalentTagCreateData,
  ): CancelablePromise<TagTalentTagCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/tag/talent-tag",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Get talent tags list
   * Get talent tags list.
   * @param data The data for the request.
   * @param data.id
   * @param data.page Page
   * @param data.pageSize Page size
   * @param data.searchQuery Filtering talent tags
   * @returns TalentTag
   * @throws ApiError
   */
  public static tagTalentTagListList(
    data: TagTalentTagListListData,
  ): CancelablePromise<TagTalentTagListListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/tag/talent-tag-list/{id}",
      path: {
        id: data.id,
      },
      query: {
        page: data.page,
        page_size: data.pageSize,
        search_query: data.searchQuery,
      },
    });
  }

  /**
   * Update talent selected tag
   * Update talent selected tag.
   * @param data The data for the request.
   * @param data.id
   * @param data.tagIds Comma-separated list of tag ID (e.g., 1,2,3)
   * @param data.requestBody
   * @returns TalentTag
   * @throws ApiError
   */
  public static tagTalentTagListUpdate(
    data: TagTalentTagListUpdateData,
  ): CancelablePromise<TagTalentTagListUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/tag/talent-tag-list/{id}",
      path: {
        id: data.id,
      },
      query: {
        tag_ids: data.tagIds,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Get talent tag options
   * Get talent tag options.
   * @param data The data for the request.
   * @param data.searchQuery Filtering talent tag options
   * @returns TalentTagOptions
   * @throws ApiError
   */
  public static tagTalentTagOptionsList(
    data: TagTalentTagOptionsListData = {},
  ): CancelablePromise<TagTalentTagOptionsListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/tag/talent-tag-options",
      query: {
        search_query: data.searchQuery,
      },
    });
  }

  /**
   * Get talent tag detail
   * Get talent tag detail by ID.
   * @param data The data for the request.
   * @param data.id
   * @returns Tag
   * @throws ApiError
   */
  public static tagTalentTagRetrieve(
    data: TagTalentTagRetrieveData,
  ): CancelablePromise<TagTalentTagRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/tag/talent-tag/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Update talent tag
   * Update talent tag.
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns Tag
   * @throws ApiError
   */
  public static tagTalentTagUpdate(
    data: TagTalentTagUpdateData,
  ): CancelablePromise<TagTalentTagUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/tag/talent-tag/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Delete talent tag
   * Delete talent tag.
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static tagTalentTagDestroy(
    data: TagTalentTagDestroyData,
  ): CancelablePromise<TagTalentTagDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/tag/talent-tag/{id}",
      path: {
        id: data.id,
      },
    });
  }
}

export class TalentViewService {
  /**
   * Talent register
   * Talent register.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns TalentFormResponses
   * @throws ApiError
   */
  public static talentViewCreate(
    data: TalentViewCreateData,
  ): CancelablePromise<TalentViewCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/talent-view",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Update bookmark status
   * Update bookmark status.
   * @param data The data for the request.
   * @param data.id
   * @param data.view View with job or news.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static talentViewBookmarkStatusUpdate(
    data: TalentViewBookmarkStatusUpdateData,
  ): CancelablePromise<TalentViewBookmarkStatusUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/talent-view/bookmark-status/{id}",
      path: {
        id: data.id,
      },
      query: {
        view: data.view,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Calculate talent job view
   * Calculate talent job view.
   * @returns unknown
   * @throws ApiError
   */
  public static talentViewCalculateTalentJobViewRetrieve(): CancelablePromise<TalentViewCalculateTalentJobViewRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent-view/calculate-talent-job-view",
    });
  }

  /**
   * Get options related talent register
   * Get options related talent register.
   * @returns OptionsRelatedTalentRegister
   * @throws ApiError
   */
  public static talentViewGetOptionsRelatedRegisterRetrieve(): CancelablePromise<TalentViewGetOptionsRelatedRegisterRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent-view/get-options-related-register",
    });
  }

  /**
   * Job list
   * Job list in the system.
   * @param data The data for the request.
   * @param data.page Page
   * @param data.pageSize Page size
   * @param data.search Search query for filtering job by title, status, type, occupation_2, public_date, number_of_views, number_of_saves, number_of_responses,...
   * @returns JobDetail
   * @throws ApiError
   */
  public static talentViewJobList(
    data: TalentViewJobListData = {},
  ): CancelablePromise<TalentViewJobListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent-view/job",
      query: {
        page: data.page,
        page_size: data.pageSize,
        search: data.search,
      },
    });
  }

  /**
   * Job list on mobile screen
   * Job list on mobile screen.
   * @param data The data for the request.
   * @param data.page page
   * @param data.pageSize page_size
   * @param data.search Search query for filtering job by title, status, type, occupation_2, public_date, number_of_views, number_of_saves, number_of_responses,...
   * @returns JobDetail
   * @throws ApiError
   */
  public static talentViewJobMobileList(
    data: TalentViewJobMobileListData = {},
  ): CancelablePromise<TalentViewJobMobileListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent-view/job-mobile",
      query: {
        page: data.page,
        page_size: data.pageSize,
        search: data.search,
      },
    });
  }

  /**
   * Check display notifications after 90 days
   * Check display notifications after 90 days.
   * @returns unknown
   * @throws ApiError
   */
  public static talentViewJobNotiQuestionRetrieve(): CancelablePromise<TalentViewJobNotiQuestionRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent-view/job-noti-question",
    });
  }

  /**
   * Save the answer to change the situation work
   * Save the answer to change the situation work.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static talentViewJobNotiQuestionCreate(
    data: TalentViewJobNotiQuestionCreateData,
  ): CancelablePromise<TalentViewJobNotiQuestionCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/talent-view/job-noti-question",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Update the answer to change the situation work
   * Update the answer to change the situation work.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static talentViewJobNotiQuestionUpdate(
    data: TalentViewJobNotiQuestionUpdateData,
  ): CancelablePromise<TalentViewJobNotiQuestionUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/talent-view/job-noti-question",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Get other job results
   * Returns other job results in the system.
   * @param data The data for the request.
   * @param data.id
   * @param data.search Search query for filtering job by title, status, type, occupation_2, public_date, number_of_views, number_of_saves, number_of_responses,...
   * @returns JobDetail
   * @throws ApiError
   */
  public static talentViewJobOtherList(
    data: TalentViewJobOtherListData,
  ): CancelablePromise<TalentViewJobOtherListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent-view/job-other/{id}",
      path: {
        id: data.id,
      },
      query: {
        search: data.search,
      },
    });
  }

  /**
   * Get 5 most suitable jobs
   * Suggest 5 most suitable jobs.
   * @param data The data for the request.
   * @param data.limit Limit number of suitable jobs
   * @param data.minItems Minimum number of suitable jobs
   * @returns JobDetail
   * @throws ApiError
   */
  public static talentViewJobSuitableList(
    data: TalentViewJobSuitableListData = {},
  ): CancelablePromise<TalentViewJobSuitableListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent-view/job-suitable",
      query: {
        limit: data.limit,
        min_items: data.minItems,
      },
    });
  }

  /**
   * Get 3 most suitable jobs
   * Suggest 3 most suitable jobs.
   * @param data The data for the request.
   * @param data.minItems Minimum number of suitable jobs
   * @param data.page page
   * @param data.pageSize page_size
   * @returns JobDetail
   * @throws ApiError
   */
  public static talentViewJobSuitableFullList(
    data: TalentViewJobSuitableFullListData = {},
  ): CancelablePromise<TalentViewJobSuitableFullListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent-view/job-suitable-full",
      query: {
        min_items: data.minItems,
        page: data.page,
        page_size: data.pageSize,
      },
    });
  }

  /**
   * Get job detail
   * Get details of a job based on ID.
   * @param data The data for the request.
   * @param data.id
   * @returns JobDetail
   * @throws ApiError
   */
  public static talentViewJobRetrieve(
    data: TalentViewJobRetrieveData,
  ): CancelablePromise<TalentViewJobRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent-view/job/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Apply for a job
   * Apply for a job based on ID.
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static talentViewJobCreate(
    data: TalentViewJobCreateData,
  ): CancelablePromise<TalentViewJobCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/talent-view/job/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Update number of view for a job
   * Update number of view for a job based on ID.
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static talentViewJobUpdate(
    data: TalentViewJobUpdateData,
  ): CancelablePromise<TalentViewJobUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/talent-view/job/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Get list news
   * Get list news.
   * @param data The data for the request.
   * @param data.page Page
   * @param data.pageSize Page size
   * @returns News
   * @throws ApiError
   */
  public static talentViewNewsList(
    data: TalentViewNewsListData = {},
  ): CancelablePromise<TalentViewNewsListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent-view/news",
      query: {
        page: data.page,
        page_size: data.pageSize,
      },
    });
  }

  /**
   * Get news detail
   * Get details of an news based on ID.
   * @param data The data for the request.
   * @param data.id
   * @returns NewsDetail
   * @throws ApiError
   */
  public static talentViewNewsDetailRetrieve(
    data: TalentViewNewsDetailRetrieveData,
  ): CancelablePromise<TalentViewNewsDetailRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent-view/news-detail/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Update pv for a news
   * Update pv for a news based on ID.
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static talentViewNewsDetailUpdate(
    data: TalentViewNewsDetailUpdateData,
  ): CancelablePromise<TalentViewNewsDetailUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/talent-view/news-detail/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * News list on mobile screen
   * News list on mobile screen.
   * @param data The data for the request.
   * @param data.page page
   * @param data.pageSize page_size
   * @returns News
   * @throws ApiError
   */
  public static talentViewNewsMobileList(
    data: TalentViewNewsMobileListData = {},
  ): CancelablePromise<TalentViewNewsMobileListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent-view/news-mobile",
      query: {
        page: data.page,
        page_size: data.pageSize,
      },
    });
  }

  /**
   * Get news recommend
   * Get news recommend of an news based on ID.
   * @param data The data for the request.
   * @param data.id
   * @returns NewsDetail
   * @throws ApiError
   */
  public static talentViewNewsRecommendList(
    data: TalentViewNewsRecommendListData,
  ): CancelablePromise<TalentViewNewsRecommendListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent-view/news-recommend/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Get list notification for talent
   * Get list notification for talent.
   * @returns unknown
   * @throws ApiError
   */
  public static talentViewNotificationRetrieve(): CancelablePromise<TalentViewNotificationRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent-view/notification",
    });
  }

  /**
   * Sync talent statistics
   * @param data The data for the request.
   * @param data.requestBody
   * @returns SyncStatisticsResponse
   * @throws ApiError
   */
  public static talentViewSyncStatisticsCreate(
    data: TalentViewSyncStatisticsCreateData = {},
  ): CancelablePromise<TalentViewSyncStatisticsCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/talent-view/sync-statistics",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Talent registration token validator
   * Validates a talent registration JWT token to ensure it was generated by the system and has not expired.
   * @param data The data for the request.
   * @param data.token Token value.
   * @returns TalentRegistrationTokenValidator
   * @throws ApiError
   */
  public static talentViewTalentRegistrationValidateRetrieve(
    data: TalentViewTalentRegistrationValidateRetrieveData,
  ): CancelablePromise<TalentViewTalentRegistrationValidateRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent-view/talent-registration-validate",
      query: {
        token: data.token,
      },
    });
  }

  /**
   * Talent register upload files
   * Talent register upload files.
   * @param data The data for the request.
   * @param data.formData
   * @returns TalentRegisterUploadFileResponse
   * @throws ApiError
   */
  public static talentViewUploadFileCreate(
    data: TalentViewUploadFileCreateData = {},
  ): CancelablePromise<TalentViewUploadFileCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/talent-view/upload-file",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }
}

export class TalentService {
  /**
   * Get detail talent
   * Get detail talent by ID.
   * @param data The data for the request.
   * @param data.id
   * @returns TalentCompanyDetail
   * @throws ApiError
   */
  public static talentRetrieve(
    data: TalentRetrieveData,
  ): CancelablePromise<TalentRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Update talent
   * Update talent information.
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static talentUpdate(
    data: TalentUpdateData,
  ): CancelablePromise<TalentUpdateResponse2> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/talent/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Advance search talent
   * Advance search talent.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns TalentSearchResponse
   * @throws ApiError
   */
  public static talentAdvancedSearchCreate(
    data: TalentAdvancedSearchCreateData = {},
  ): CancelablePromise<TalentAdvancedSearchCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/talent/advanced-search",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Approve bulk talent
   * Approve multiple talent registration requests with a 5-minute delay.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns ApproveBulkResponse
   * @throws ApiError
   */
  public static talentApproveBulkCreate(
    data: TalentApproveBulkCreateData,
  ): CancelablePromise<TalentApproveBulkCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/talent/approve-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Approve talent
   * Approve talent
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static talentApproveRetrieve(
    data: TalentApproveRetrieveData,
  ): CancelablePromise<TalentApproveRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent/approve/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Schedule message list
   * Schedule message list.
   * @param data The data for the request.
   * @param data.endDate End date of the range
   * @param data.page Page
   * @param data.pageSize Page size
   * @param data.search Search query for filtering job by created_at, type, screen_name, detail
   * @param data.sortBy Field to sort by (e.g., department, position)
   * @param data.startDate Start date of the range
   * @returns ScheduleChat
   * @throws ApiError
   */
  public static talentBulkMessageList(
    data: TalentBulkMessageListData = {},
  ): CancelablePromise<TalentBulkMessageListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent/bulk-message",
      query: {
        end_date: data.endDate,
        page: data.page,
        page_size: data.pageSize,
        search: data.search,
        sort_by: data.sortBy,
        start_date: data.startDate,
      },
    });
  }

  /**
   * Add talent bulk messages.
   * Add talent bulk messages.
   * @param data The data for the request.
   * @param data.formData
   * @returns unknown
   * @throws ApiError
   */
  public static talentBulkMessageCreate(
    data: TalentBulkMessageCreateData = {},
  ): CancelablePromise<TalentBulkMessageCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/talent/bulk-message",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * Update talent bulk messages.
   * Update talent bulk messages.
   * @param data The data for the request.
   * @param data.formData
   * @returns ScheduleChat
   * @throws ApiError
   */
  public static talentBulkMessageUpdate(
    data: TalentBulkMessageUpdateData = {},
  ): CancelablePromise<TalentBulkMessageUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/talent/bulk-message",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * Get detail talent bulk messages
   * Get detail talent bulk messages by ID.
   * @param data The data for the request.
   * @param data.id
   * @returns ScheduleChatDetail
   * @throws ApiError
   */
  public static talentBulkMessageRetrieve(
    data: TalentBulkMessageRetrieveData,
  ): CancelablePromise<TalentBulkMessageRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent/bulk-message/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Pause bulk messages
   * Pause bulk messages.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static talentBulkMessagePauseCreate(
    data: TalentBulkMessagePauseCreateData,
  ): CancelablePromise<TalentBulkMessagePauseCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/talent/bulk-message/pause",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Cancel bulk approve talent
   * Cancel approval of multiple talent registration requests during the 5-minute delayed execution window.
   * @returns CancelApproveBulkResponse
   * @throws ApiError
   */
  public static talentCancelApproveBulkCreate(): CancelablePromise<TalentCancelApproveBulkCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/talent/cancel-approve-bulk",
    });
  }

  /**
   * Cancel approve talent
   * Cancel approval of a talent registration request during the 5-minute delayed execution window.
   * @param data The data for the request.
   * @param data.id
   * @returns CancelApproveTalentResponse
   * @throws ApiError
   */
  public static talentCancelApproveRetrieve(
    data: TalentCancelApproveRetrieveData,
  ): CancelablePromise<TalentCancelApproveRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent/cancel-approve/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Cancel talent
   * Cancel talent.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static talentCancelTalentCreate(
    data: TalentCancelTalentCreateData,
  ): CancelablePromise<TalentCancelTalentCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/talent/cancel-talent",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Get registration details by token
   * Get CSV-imported talent registration details by token for pre-filling the registration form.
   * @param data The data for the request.
   * @param data.authorization Bearer registration token
   * @param data.xRegistrationToken Registration token header
   * @param data.token Confirm registration token (optional if provided via Authorization or X-Registration-Token header)
   * @returns ConfirmRegistrationGetResponse
   * @throws ApiError
   */
  public static talentConfirmRegistrationRetrieve(
    data: TalentConfirmRegistrationRetrieveData = {},
  ): CancelablePromise<TalentConfirmRegistrationRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent/confirm-registration",
      headers: {
        Authorization: data.authorization,
        "X-Registration-Token": data.xRegistrationToken,
      },
      query: {
        token: data.token,
      },
    });
  }

  /**
   * Confirm talent registration
   * Confirm CSV-imported talent registration details (first name, last name, password, birth date).
   * @param data The data for the request.
   * @param data.requestBody
   * @returns ConfirmRegistrationResponse
   * @throws ApiError
   */
  public static talentConfirmRegistrationCreate(
    data: TalentConfirmRegistrationCreateData,
  ): CancelablePromise<TalentConfirmRegistrationCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/talent/confirm-registration",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Delete talent register
   * Delete talent register.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns TalentDeleteResponse
   * @throws ApiError
   */
  public static talentDeleteCreate(
    data: TalentDeleteCreateData,
  ): CancelablePromise<TalentDeleteCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/talent/delete",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Execute delayed approve talent task from GCP Cloud Tasks
   * Endpoint triggered by GCP Cloud Tasks to approve talent after 5-minute delay.
   * @param data The data for the request.
   * @param data.authorization Google OIDC Bearer Token for Cloud Tasks authentication (e.g. "Bearer <id_token>")
   * @param data.requestBody
   * @returns ExecuteApproveTalentTaskResponse
   * @throws ApiError
   */
  public static talentExecuteCloudTaskApproveCreate(
    data: TalentExecuteCloudTaskApproveCreateData,
  ): CancelablePromise<TalentExecuteCloudTaskApproveCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/talent/execute-cloud-task-approve",
      headers: {
        Authorization: data.authorization,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Get list talent register
   * Get list talent register.
   * @param data The data for the request.
   * @param data.page Page
   * @param data.pageSize Page size
   * @param data.registerChannel Filtering register channel
   * @param data.searchQuery Filtering talent
   * @param data.sortBy Field to sort by (e.g., updated_at)
   * @param data.sortOrder Sort order (asc or desc)
   * @param data.status Filtering talent status
   * @returns TalentTemp
   * @throws ApiError
   */
  public static talentGetListNewList(
    data: TalentGetListNewListData = {},
  ): CancelablePromise<TalentGetListNewListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent/get-list-new",
      query: {
        page: data.page,
        page_size: data.pageSize,
        register_channel: data.registerChannel,
        search_query: data.searchQuery,
        sort_by: data.sortBy,
        sort_order: data.sortOrder,
        status: data.status,
      },
    });
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static talentGetOptionsRelatedRetrieve(): CancelablePromise<TalentGetOptionsRelatedRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent/get-options-related",
    });
  }

  /**
   * Import talent from CSV file
   * Import talent from CSV file as JSON payload.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns ImportTalentResponse
   * @throws ApiError
   */
  public static talentImportCreate(
    data: TalentImportCreateData,
  ): CancelablePromise<TalentImportCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/talent/import",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Get list job recommend for search talent
   * Get list job recommend for search talent.
   * @param data The data for the request.
   * @param data.search
   * @returns TalentJobRecommend
   * @throws ApiError
   */
  public static talentJobRecommendRetrieve(
    data: TalentJobRecommendRetrieveData = {},
  ): CancelablePromise<TalentJobRecommendRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent/job-recommend",
      query: {
        search: data.search,
      },
    });
  }

  /**
   * Get list news recommend for search talent
   * Get list news recommend for search talent.
   * @param data The data for the request.
   * @param data.search
   * @returns TalentJobRecommend
   * @throws ApiError
   */
  public static talentNewsRecommendRetrieve(
    data: TalentNewsRecommendRetrieveData = {},
  ): CancelablePromise<TalentNewsRecommendRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent/news-recommend",
      query: {
        search: data.search,
      },
    });
  }

  /**
   * Search referrer talent
   * Search referrer talent.
   * @param data The data for the request.
   * @param data.searchText
   * @returns unknown
   * @throws ApiError
   */
  public static talentReferrerTalentRetrieve(
    data: TalentReferrerTalentRetrieveData = {},
  ): CancelablePromise<TalentReferrerTalentRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent/referrer-talent",
      query: {
        search_text: data.searchText,
      },
    });
  }

  /**
   * Resend email approved talent
   * Resend email approved talent
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static talentResendApproveEmailRetrieve(
    data: TalentResendApproveEmailRetrieveData,
  ): CancelablePromise<TalentResendApproveEmailRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent/resend-approve-email/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Save imported talent
   * Save imported talent from temp import table to main tables.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns SaveImportTalentResponse
   * @throws ApiError
   */
  public static talentSaveImportCreate(
    data: TalentSaveImportCreateData = {},
  ): CancelablePromise<TalentSaveImportCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/talent/save-import",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Get talent statistics
   * Get talent statistics.
   * @param data The data for the request.
   * @param data.rankAOnly Filter to include only talent company with rank A
   * @param data.search Search query for filtering talent
   * @param data.talentType Talent type filter
   * @param data.time Filtering talent by time
   * @returns StatisticsTalent
   * @throws ApiError
   */
  public static talentStatisticsRetrieve(
    data: TalentStatisticsRetrieveData = {},
  ): CancelablePromise<TalentStatisticsRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/talent/statistics",
      query: {
        rank_a_only: data.rankAOnly,
        search: data.search,
        talent_type: data.talentType,
        time: data.time,
      },
    });
  }

  /**
   * Update talent infomation
   * Update talent infomation.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns TalentUpdateResponse
   * @throws ApiError
   */
  public static talentUpdateInfoCreate(
    data: TalentUpdateInfoCreateData,
  ): CancelablePromise<TalentUpdateInfoCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/talent/update-info",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Update talent resume
   * Update talent resume.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns TalentResumeUpdateResponse
   * @throws ApiError
   */
  public static talentUpdateResumeCreate(
    data: TalentUpdateResumeCreateData,
  ): CancelablePromise<TalentUpdateResumeCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/talent/update-resume",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class UpdateAdminSessionTimeOutService {
  /**
   * Update admin session time out
   * Update admin session time out.
   * @param data The data for the request.
   * @param data.min
   * @returns unknown
   * @throws ApiError
   */
  public static updateAdminSessionTimeOutRetrieve(
    data: UpdateAdminSessionTimeOutRetrieveData,
  ): CancelablePromise<UpdateAdminSessionTimeOutRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/update-admin-session-time-out/{min}",
      path: {
        min: data.min,
      },
    });
  }

  /**
   * Update admin session time out
   * Update admin session time out.
   * @param data The data for the request.
   * @param data.min
   * @param data.requestBody
   * @returns UpdateAdminSessionResponse
   * @throws ApiError
   */
  public static updateAdminSessionTimeOutCreate(
    data: UpdateAdminSessionTimeOutCreateData,
  ): CancelablePromise<UpdateAdminSessionTimeOutCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/update-admin-session-time-out/{min}",
      path: {
        min: data.min,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class ControlService {
  /**
   * Get list companys
   * Get list companys.
   * @param data The data for the request.
   * @param data.page Page
   * @param data.pageSize Page size
   * @param data.searchQuery Filtering company
   * @param data.sortBy Field to sort by (e.g., department, position)
   * @param data.sortOrder Sort order (e.g., last_name, email)
   * @returns ListCompanyPaging
   * @throws ApiError
   */
  public static controlApiCompanyList(
    data: ControlApiCompanyListData = {},
  ): CancelablePromise<ControlApiCompanyListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/control/api/company",
      query: {
        page: data.page,
        page_size: data.pageSize,
        search_query: data.searchQuery,
        sort_by: data.sortBy,
        sort_order: data.sortOrder,
      },
    });
  }

  /**
   * Add new company
   * Add new company.
   * @param data The data for the request.
   * @param data.formData
   * @returns CompanyDetail
   * @throws ApiError
   */
  public static controlApiCompanyCreate(
    data: ControlApiCompanyCreateData = {},
  ): CancelablePromise<ControlApiCompanyCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/control/api/company",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * Get detail company
   * Get detail company by ID.
   * @param data The data for the request.
   * @param data.id
   * @returns CompanyDetail
   * @throws ApiError
   */
  public static controlApiCompanyRetrieve(
    data: ControlApiCompanyRetrieveData,
  ): CancelablePromise<ControlApiCompanyRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/control/api/company/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Update company
   * Update company.
   * @param data The data for the request.
   * @param data.id
   * @param data.formData
   * @returns CompanyDetail
   * @throws ApiError
   */
  public static controlApiCompanyUpdate(
    data: ControlApiCompanyUpdateData,
  ): CancelablePromise<ControlApiCompanyUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/control/api/company/{id}",
      path: {
        id: data.id,
      },
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * Delete company
   * Delete company.
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static controlApiCompanyDestroy(
    data: ControlApiCompanyDestroyData,
  ): CancelablePromise<ControlApiCompanyDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/control/api/company/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Export list companys to csv
   * Export list companys to csv.
   * @param data The data for the request.
   * @param data.searchQuery Filtering company
   * @param data.sortBy Field to sort by (e.g., department, position)
   * @param data.sortOrder Sort order (e.g., last_name, email)
   * @returns unknown
   * @throws ApiError
   */
  public static controlApiCompanyExportCsvRetrieve(
    data: ControlApiCompanyExportCsvRetrieveData = {},
  ): CancelablePromise<ControlApiCompanyExportCsvRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/control/api/company/export_csv",
      query: {
        search_query: data.searchQuery,
        sort_by: data.sortBy,
        sort_order: data.sortOrder,
      },
    });
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static controlApiCompanyGetDefaultCompanyIdRetrieve(): CancelablePromise<ControlApiCompanyGetDefaultCompanyIdRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/control/api/company/get-default-company-id",
    });
  }

  /**
   * Get list departments
   * Get list departments.
   * @param data The data for the request.
   * @param data.companyId Company ID
   * @returns Department
   * @throws ApiError
   */
  public static controlApiDepartmentList(
    data: ControlApiDepartmentListData,
  ): CancelablePromise<ControlApiDepartmentListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/control/api/department",
      query: {
        company_id: data.companyId,
      },
    });
  }

  /**
   * Add new department
   * Add new department.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static controlApiDepartmentCreate(
    data: ControlApiDepartmentCreateData,
  ): CancelablePromise<ControlApiDepartmentCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/control/api/department",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Get detail department
   * Get detail department by ID.
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static controlApiDepartmentRetrieve(
    data: ControlApiDepartmentRetrieveData,
  ): CancelablePromise<ControlApiDepartmentRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/control/api/department/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Update department
   * Update department.
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static controlApiDepartmentUpdate(
    data: ControlApiDepartmentUpdateData,
  ): CancelablePromise<ControlApiDepartmentUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/control/api/department/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Delete department
   * Delete department.
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static controlApiDepartmentDestroy(
    data: ControlApiDepartmentDestroyData,
  ): CancelablePromise<ControlApiDepartmentDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/control/api/department/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Get list positions
   * Get list positions.
   * @param data The data for the request.
   * @param data.companyId Company ID
   * @returns Position
   * @throws ApiError
   */
  public static controlApiPositionList(
    data: ControlApiPositionListData,
  ): CancelablePromise<ControlApiPositionListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/control/api/position",
      query: {
        company_id: data.companyId,
      },
    });
  }

  /**
   * Add new position
   * Add new position.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static controlApiPositionCreate(
    data: ControlApiPositionCreateData,
  ): CancelablePromise<ControlApiPositionCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/control/api/position",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Update position
   * Update position.
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static controlApiPositionUpdate(
    data: ControlApiPositionUpdateData,
  ): CancelablePromise<ControlApiPositionUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/control/api/position/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Delete position
   * Delete position.
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static controlApiPositionDestroy(
    data: ControlApiPositionDestroyData,
  ): CancelablePromise<ControlApiPositionDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/control/api/position/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Get list super users
   * Get list super users.
   * @param data The data for the request.
   * @param data.page Page
   * @param data.pageSize Page size
   * @param data.searchQuery Filtering super user
   * @param data.sortBy Field to sort by (e.g., last_name, email)
   * @param data.sortOrder Sort order (e.g., last_name, email)
   * @returns ListSuperUserPaging
   * @throws ApiError
   */
  public static controlApiSuperUserList(
    data: ControlApiSuperUserListData = {},
  ): CancelablePromise<ControlApiSuperUserListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/control/api/super-user",
      query: {
        page: data.page,
        page_size: data.pageSize,
        search_query: data.searchQuery,
        sort_by: data.sortBy,
        sort_order: data.sortOrder,
      },
    });
  }

  /**
   * Add new super user
   * Add new super user.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns SuperUserDetail
   * @throws ApiError
   */
  public static controlApiSuperUserCreate(
    data: ControlApiSuperUserCreateData,
  ): CancelablePromise<ControlApiSuperUserCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/control/api/super-user",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Super user login
   * Super user login.
   * @returns SuperUserLoginSuccessResponse
   * @throws ApiError
   */
  public static controlApiSuperUserLoginCreate(): CancelablePromise<ControlApiSuperUserLoginCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/control/api/super-user-login",
    });
  }

  /**
   * Get detail super user
   * Get detail super user by ID.
   * @param data The data for the request.
   * @param data.id
   * @returns SuperUserDetail
   * @throws ApiError
   */
  public static controlApiSuperUserRetrieve(
    data: ControlApiSuperUserRetrieveData,
  ): CancelablePromise<ControlApiSuperUserRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/control/api/super-user/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Update super user
   * Update super user.
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns SuperUserDetail
   * @throws ApiError
   */
  public static controlApiSuperUserUpdate(
    data: ControlApiSuperUserUpdateData,
  ): CancelablePromise<ControlApiSuperUserUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/control/api/super-user/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Delete super user
   * Delete super user.
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static controlApiSuperUserDestroy(
    data: ControlApiSuperUserDestroyData,
  ): CancelablePromise<ControlApiSuperUserDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/control/api/super-user/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Change admin company
   * Change admin company.
   * @param data The data for the request.
   * @param data.companyId
   * @param data.requestBody
   * @returns ChangeAdminCompanyResponse
   * @throws ApiError
   */
  public static controlApiSuperUserChangeAdminCompanyCreate(
    data: ControlApiSuperUserChangeAdminCompanyCreateData,
  ): CancelablePromise<ControlApiSuperUserChangeAdminCompanyCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/control/api/super-user/change-admin-company/{company_id}",
      path: {
        company_id: data.companyId,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static controlApiSuperUserGetOptionsRelatedRetrieve(): CancelablePromise<ControlApiSuperUserGetOptionsRelatedRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/control/api/super-user/get-options-related",
    });
  }

  /**
   * Update avatar super user
   * Update avatar super user based on ID.
   * @param data The data for the request.
   * @param data.id
   * @param data.formData
   * @returns SuperUserDetail
   * @throws ApiError
   */
  public static controlApiSuperUserUpdateAvatarUpdate(
    data: ControlApiSuperUserUpdateAvatarUpdateData,
  ): CancelablePromise<ControlApiSuperUserUpdateAvatarUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/control/api/super-user/update-avatar/{id}",
      path: {
        id: data.id,
      },
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }
}
